import React, { Component } from 'react'

class CreateCustomer extends Component{
  renderSnippet = (htmlSnippet) => {
     var checkoutContainer = document.getElementById('my-checkout-container')
     checkoutContainer.innerHTML = htmlSnippet
     var scriptsTags = checkoutContainer.getElementsByTagName('script')
     for (var i = 0; i < scriptsTags.length; i++) {
         var parentNode = scriptsTags[i].parentNode
         var newScriptTag = document.createElement('script')
         newScriptTag.type = 'text/javascript'
         newScriptTag.text = scriptsTags[i].text
         parentNode.removeChild(scriptsTags[i])
         parentNode.appendChild(newScriptTag)
     }
  }

  componentDidMount() {
    const token = localStorage.getItem("admin-token")
    let headers = {"Content-Type": "application/json"};
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch("/api/admin/klarna/checkout", {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(JsonResponse => {
            return this.renderSnippet(JsonResponse.htmlSnippet)
          })
        } else {
          throw res.status
        }
     })
  }

  render() {
    return(
      <div>
        <h1>Skapa användare</h1>
        <h4>OBS Öppna fönstret i incognito</h4>
        <div className="Products-body">
          <div id="my-checkout-container">
          </div>          
        </div>
      </div>
    )
  }
}

export default CreateCustomer



// WEBPACK FOOTER //
// ./src/containers/admin/containers/CreateCustomer.jsx